<template>
  <div
    id="messageBox"
    :class="[
      isShowEvaluatePage ? 'mb' : '',
      listStatus ? 'penetrate' : 'nopenetrate',
      isSpecial ? 'isSpecial' : ''
    ]"
    class="chat-message-box istouch"
    ref="box"
    @scroll="whereScorll()"
  >
    <!-- <div class="lookHistory" v-if="needShowBtn() && !hasHistoryLoad">
      <span @click="addMoreHistory">点击查看历史记录</span>
    </div> -->
    <!-- <div class="hisLastTime" v-if="hisLastTime && !hasHistoryLoad && !isQueue">
      {{ hisLastTime | datetime }}
    </div> -->
    <div v-if="hasHistoryLoad" class="lookHistory lookHistoryLoad">
      <i class="el-icon-loading" />加载中
    </div>
    <slot>
      <div v-if="showNoHistory() && !hasHistoryLoad" class="no-more">
        暂无更多历史消息
      </div>
      <div
        id="chat-message-wraper"
        class="messages-layout"
        :style="{
          paddingBottom: padNum + 'px',
          minHeight: isQueue || blackFlag != 0 ? 'auto' : paddingTop
        }"
        @click="hideMore"
        :class="[ismarqueue ? 'padding_top' : '']"
      >
        <template v-for="(item, index) in messages">
          <div
            :id="`customer-pc-msg-${index}`"
            :key="(item.msgId || 'msg-') + index + 'pcmessages'"
          >
            <div class="tip" v-if="item.conversationTip == tip">
              <div class="left_border"></div>
              <div class="content">
                本次会话的消息
              </div>
              <div class="right_border"></div>
              <div class="clear"></div>
              <div v-if="isShowNotice">
                <div
                  v-for="(option, i) in NoticeMessage.noticeInfo"
                  :key="i + 3"
                >
                  <div
                    id="notice"
                    v-if="option.noticeType == 2"
                    v-html="Noticetext"
                  ></div>
                </div>
                <div v-for="(option, i) in NoticeMessage.noticeInfo" :key="i">
                  <el-row
                    v-if="option.noticeType == 1 && NoticeMessage"
                    class="nocticeImg"
                    :gutter="20"
                  >
                    <el-col
                      v-for="(imgItem, j) in option.noticeInfoPhoto"
                      :key="j"
                      :span="8"
                    >
                      <img
                        v-if="imgItem.linkType == -1"
                        :src="imgItem.noticeImg"
                        alt="图片通知"
                      />
                      <div class="imgText" v-if="imgItem.linkType == -1">
                        {{ imgItem.noticeTitle }}
                      </div>
                      <a
                        :href="DoMain + imgItem.noticeUrl"
                        target="_blank"
                        v-if="imgItem.linkType == 0"
                      >
                        <img :src="imgItem.noticeImg" alt="图片通知" />
                      </a>
                      <div class="imgText" v-if="imgItem.linkType == 0">
                        {{ imgItem.noticeTitle }}
                      </div>
                      <a
                        :href="imgItem.noticeUrl"
                        v-if="imgItem.linkType == 1"
                        target="_blank"
                      >
                        <img :src="imgItem.noticeImg" alt="图片通知" />
                      </a>
                      <div class="imgText" v-if="imgItem.linkType == 1">
                        {{ imgItem.noticeTitle }}
                      </div>
                    </el-col>
                  </el-row>
                </div>
              </div>
            </div>
            <chat-message-item
              :message="item"
              @clickImage="clickImage"
              @errorImg="errorImg"
            />
          </div>
        </template>
      </div>
      <viewer
        :options="options"
        :images="images"
        @inited="inited"
        class="viewer"
        ref="viewer"
      >
        <template slot-scope="scope">
          <img v-for="src in scope.images" :src="src" :key="src" />
        </template>
      </viewer>
      <!-- <el-image-viewer
        v-if="showViewer"
        :on-close="closeViewer"
        :on-switch="onSwitch"
        :url-list="images"
      /> -->
    </slot>
    <div v-show="showBottom" class="moreMsg" @click="scrollBottom">
      <span> <i class="el-icon-bottom"></i>回到底部</span>
    </div>
    <div id="btns" class="viewer-toolbar">
      <span @click="left" class="el-image-viewer__btn el-image-viewer__prev"
        ><i class="el-icon-arrow-left"></i
      ></span>
      <span @click="right" class="el-image-viewer__btn el-image-viewer__next"
        ><i class="el-icon-arrow-right"></i
      ></span>
      <div
        class="el-image-viewer__btn el-image-viewer__actions btns"
        ref="btns"
      >
        <div class="el-image-viewer__actions__inner">
          <i @click="scaleMin" class="el-icon-zoom-out"></i>
          <i @click="scaleMax" class="el-icon-zoom-in"></i>
          <i @click="one" class="el-icon-c-scale-to-original"></i>
          <i @click="roteleft" class="el-icon-refresh-left"></i>
          <i @click="roteright" class="el-icon-refresh-right"></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import chatMessageItem from "./chat-message-item";
// import ElImageViewer from "element-ui/packages/image/src/image-viewer";
import constant from "src/constant";
import constants from "../../constant";
import historyReconcileScroll from "src/mixins/historyReconcileScroll";
// import orderList from "src/app/customer/components/orderList";
export default {
  name: "chat-message-box",
  components: { chatMessageItem }, //, ElImageViewer
  mixins: [historyReconcileScroll],
  data() {
    return {
      Noticetext: "",
      Noticeimages: [],
      direction: "btt",
      time: null,
      historyNeedScorll: false,
      iScroll: true, //滚动到顶部是否请求历史记录
      index: null,
      padNum: 0,
      showBottom: false,
      scrollTop: 0,
      clientHeight: 0,
      tip: constant.MESSAGE_TYPE.MT_CHANNEL_TIP,
      isHistory: false,
      paddingTop: 0,
      images: [],
      showViewer: false,
      options: {
        zIndex: 9999,
        loop: false,
        title: false,
        toolbar: false,
        hide() {
          document.getElementById("btns").style.display = "none";
          document.getElementById("messageBox").classList.add("istouch");
        },
        show: function() {
          document.getElementById("messageBox").classList.remove("istouch");
          document.getElementById("btns").style.display = "block";
        }
      }
    };
  },
  computed: {
    ...mapGetters(["messages"]),
    ...mapState({
      isShowLookhistory: state => state.isShowLookhistory,
      messagePageNumber: state => state.messagePageNumber,
      currCustomer: state => state.currCustomer,
      isBeforeConnect: state => state.isBeforeConnect,
      isShowHistoryBtn: state => state.isShowHistoryBtn,
      hasHistory: state => state.hasHistory,
      isConversation: state => state.isConversation,
      isEntering: state => state.isEntering,
      isSendFlag: state => state.isSendFlag,
      isShowEvaluatePage: state => state.isShowEvaluatePage,
      hasHistoryLoad: state => state.hasHistoryLoad,
      isQueue: state => state.isQueue,
      blackFlag: state => state.blackFlag,
      beginTime: state => state.beginTime,
      listStatus: state => state.listStatus,
      isShowNotice: state => state.isShowNotice,
      NoticeMessage: state => state.NoticeMessage,
      DoMain: state => state.DoMain,
      ismarqueue: state => state.ismarqueue,
      enterScene: state => state.enterScene
    }),
    imageMap() {
      let map = {};
      this.messageImages.forEach(item => {
        map[item.msgId] = item;
      });
      return map;
    },
    messageImages() {
      return this.messages
        .filter(
          item =>
            item.type === constant.MESSAGE_TYPE.MT_IMAGE ||
            item.type === constant.MESSAGE_TYPE.MT_TEXT_PHOTO ||
            item.type === constant.MESSAGE_TYPE.MT_TEXT_CURRENCY
        )
        .map((item, index) => {
          this.images.push(item.filePath);
          return {
            index,
            msgId: item.msgId,
            title: this.formatTimeStamp(item.chatTime),
            src: item.localPath || item.filePath
          };
        });
    },
    hisLastTime() {
      // console.log(this.messages);
      if (this.messages.length > 0) {
        return this.messages[0].chatTime;
      } else {
        return 0;
      }
    },
    isSpecial() {
      const enterId = parseInt(this.enterScene, 10);
      return enterId == constants.WakeUpScene.special || enterId == 2002;
    }
  },
  watch: {
    messages(val, old) {
      if (this.preserveHistoryReconcileViewport(val, old)) return;
      if (val.length != old.length) {
        if (this.isHistory) {
          return false;
        }
        if (!this.isSendFlag) {
          this.isScroll();
        } else {
          this.scrollBottom();
          this.showBottom = false;
        }
      }
    },
    // isSendFlag(val) {
    //   if (val) {
    //     this.scrollBottom();
    //     this.showBottom = false;
    //   }
    // },
    isEntering() {
      if (this.isEntering) {
        this.padNum = 20;
        this.isIos();
      } else {
        this.padNum = 0;
        this.isIos();
      }
    }
  },
  mounted() {
    document.getElementById("btns").style.display = "none";
    this.eventBus.$on("scrollMessageBox", this.handleScrollMessageBox);
    if (this.messages.length > 0) {
      window.addEventListener("scroll", this.whereScorll, true);
    }
    this.clientHeight = document.documentElement
      ? document.documentElement.clientHeight
      : document.body.clientHeight;
    this.paddingTop = this.clientHeight - 72 + "px";
    this.isIos();

    const _this = this;
    setInterval(function() {
      if (_this.isShowNotice && _this.Noticetext === "") {
        _this.filleLink();
      }
    }, 1000);
  },
  methods: {
    handleScrollMessageBox() {
      this.$nextTick(() => {
        const messageBox = document.querySelector("#messageBox");
        // 判断滚动条是否在最下面
        messageBox.scrollTop =
          messageBox.scrollHeight - messageBox.offsetHeight;
        scrollBy(0, messageBox.scrollHeight);
        document.body.scrollTop = messageBox.scrollHeight;
      });
    },
    // 按钮
    one() {
      this.$viewer.reset();
    },
    left() {
      this.$viewer.prev();
      // 9 methods are available here:"hide", "view", "prev", "next", "play", "stop", "full", "exit" and "destroy".
    },
    right() {
      this.$viewer.next();
    },
    scaleMax() {
      this.$viewer.zoom(0.1);
    },
    scaleMin() {
      this.$viewer.zoom(-0.1);
    },
    roteleft() {
      this.$viewer.rotate(90);
    },
    roteright() {
      this.$viewer.rotate(-90);
    },
    isIos() {
      let u = navigator.userAgent;
      if (u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)) {
        this.padNum += 65;
      }
    },
    inited(viewer) {
      this.$viewer = viewer;
    },
    hideMore() {
      this.$store.commit(
        "setState",
        {
          more: false,
          isshowsend: false
        },
        { root: true }
      );
    },
    errorImg(message) {
      this.$store.commit("setState", {
        messages: this.messages.map(item =>
          item.msgId === message.msgId
            ? (item.serverImage = this.serverAvatar)
            : item.serverImage
        )
      });
    },
    formatMessageDate(message) {
      return moment(_.get(message, "chatTime"), "x").format(
        "YYYY-MM-DD HH:mm:ss"
      );
    },
    isDayFirstMessage(message, index) {
      if (this.isBeforeConnect) {
        return false;
      }
      if (index <= 0) {
        return true;
      } else {
        let prevMessageTime = this.messages[index - 1];
        const prevMessageDate = moment(prevMessageTime.chatTime, "x").get(
          "date"
        );
        const currMsgDate = moment(message.chatTime, "x").get("date");
        return currMsgDate !== prevMessageDate;
      }
    },
    // onSwitch(index) {
    //   this.index = index;
    // },
    // closeViewer() {
    //   this.images = [];
    //   this.showViewer = false;
    // },
    clickImage(message) {
      this.images = [];
      this.index = _.get(this, `imageMap[${message.msgId}].index`, null);
      document.getElementById("btns").style.display = "block";
      this.$viewer.index = this.index;
      this.$viewer.show();
      // this.index = _.get(this, `imageMap[${message.msgId}].index`, null);
      // this.images.forEach((element, i) => {
      //   if (i < this.index) {
      //     this.images.push(this.images[i]);
      //     delete this.images[i];
      //   }
      // });
      // this.images = this.images.filter(function(e) {
      //   return e;
      // });
      // this.showViewer = true;
    },
    openImg() {
      document.querySelector(".header").style.zIndex = "-1";
      document.querySelector(".page-footer").style.zIndex = "-1";
    },
    closeImg() {
      this.index = null;
      document.querySelector(".header").style.zIndex = "5";
      document.querySelector(".page-footer").style.zIndex = "1";
    },
    async whereScorll() {
      if (this.messages.length > 0) {
        let e = document.querySelector("#messageBox");
        this.scrollTop =
          document.querySelector("#messageBox").scrollTop ||
          document.body.scrollTop ||
          document.documentElement.scrollTop ||
          window.pageYOffset;
        this.clientHeight = document.documentElement
          ? document.documentElement.clientHeight
          : document.body.clientHeight;
        if (e.scrollHeight - this.scrollTop - 200 < this.clientHeight) {
          this.showBottom = false;
        } else {
          this.showBottom = true;
        }
        if (
          this.scrollTop == 0 &&
          !this.showNoHistory() &&
          !this.isQueue &&
          this.beginTime != "-1" &&
          this.iScroll
        ) {
          this.iScroll = false;
          try {
            await this.addMoreHistory();
          } finally {
            this.iScroll = true;
          }
          // clearTimeout(this.time);
          // this.time = setTimeout(() => {
          //   this.iScroll = true;
          // }, 1000);
        }
        this.isHistory = false;
      }
      // this.$store.commit("setState", {
      //   isSendFlag: false
      // });
    },
    isScroll() {
      this.$nextTick(() => {
        const messageBox = document.querySelector("#messageBox");
        // messageBox.scrollIntoView();
        window.messageBox = messageBox;
        clearTimeout(this.time);
        this.time = setTimeout(() => {
          if (!this.historyNeedScorll) {
            if (!this.showBottom) {
              messageBox.scrollTop = messageBox.scrollHeight + 210;
              scrollBy(0, messageBox.scrollHeight);
              document.body.scrollTop = messageBox.scrollHeight;
            }
          } else {
            this.historyNeedScorll = false;
          }
        }, 100);
      });
    },
    scrollBottom() {
      this.$nextTick(() => {
        const messageBox = document.querySelector("#messageBox");
        window.messageBox = messageBox;
        clearTimeout(this.time);
        this.time = setTimeout(() => {
          if (!this.historyNeedScorll) {
            messageBox.scrollTop = messageBox.scrollHeight + 200;
            scrollBy(0, messageBox.scrollHeight);
            document.body.scrollTop = messageBox.scrollHeight;
          } else {
            this.historyNeedScorll = false;
          }
        }, 100);
      });
      this.showBottom = false;
    },
    filleLink() {
      if (this.NoticeMessage.noticeInfo) {
        this.NoticeMessage.noticeInfo.forEach(element => {
          if (element.noticeType == 2) {
            this.Noticetext = element.noticeContent;
          }
        });
      }
      // this.Noticetext = this.Noticetext.replace(/<a/g, "<a target='_blank'");
      let elem_buff = document.createElement("div");
      elem_buff.innerHTML = this.Noticetext;
      let as = elem_buff.getElementsByTagName("a");
      // console.log(as, as.length, "ad");
      if (as.length == 0) {
        return this.Noticetext;
      }
      for (let i = 0; i < as.length; i++) {
        let href = as[i].getAttribute("href");
        if (href.indexOf("www") < 0 || href.indexOf("http") < 0) {
          as[i].setAttribute("href", this.DoMain + href);
        }
      }
      this.Noticetext = elem_buff.innerHTML;
    },
    needShowBtn() {
      return !!this.hasHistory && this.isConversation;
    },
    showNoHistory() {
      return !this.hasHistory && this.isConversation;
    },
    addMoreHistory() {
      // this.$store.commit("setState", {
      //   isShowHistoryBtn: false
      // });

      this.historyNeedScorll = false;
      // messagePageNumber,
      let { currCustomer } = this;
      // if (messagePageNumber <= 1) {
      //   this.$store.commit("clearAllMessages");
      // }

      // messagePageNumber++;
      // this.$store.commit("setState", {
      //   messagePageNumber
      // });
      return this.$store.dispatch("getMessages", currCustomer);
    }
  },
  beforeDestroy() {
    clearTimeout(this.time);
    this.eventBus.$off("scrollMessageBox", this.handleScrollMessageBox);
    window.removeEventListener("scroll", this.whereScorll, true);
  }
};
</script>
<style lang="less">
.padding_top {
  padding-top: 30px !important;
}
.el-col-8 {
  text-align: center;
}
#messageBox .btns {
  position: fixed;
  -webkit-transform: translateZ(999999999px);
  transform: translateZ(999999999px);
  z-index: 99999;
  bottom: 15vw;
  left: 0;
  right: 0;
  margin: auto;
}
.el-drawer__header {
  margin-bottom: 0 !important;
}
.imgText {
  text-align: center;
}
.hisLastTime {
  background-color: #fff;
  border-radius: 50px;
  position: fixed;
  top: 68px;
  text-align: center;
  left: 0;
  right: 0;
  width: 100px;
  margin: auto;
  font-size: 13px;
  padding: 10px 2px;
  color: #787878;
}
.viewer img {
  display: none;
}
/* .viewer-canvas img {
  margin: auto !important;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
} */
</style>
<style lang="less" scoped>
.mb {
  margin-bottom: 100px;
}
.istouch {
  -webkit-overflow-scrolling: touch;
}

.isSpecial {
  padding-top: 0 !important;
}

.chat-message-box {
  background: #fff;
  .nocticeImg {
    padding-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      width: 100%;
      max-width: 90px;
      border-radius: 5px;
    }
  }
  .el-image-viewer__prev {
    position: fixed;
    left: 10px;
    top: 43vh;
    color: #fff;
    z-index: 10000;
  }
  .el-image-viewer__next {
    position: fixed;
    right: 10px;
    top: 43vh;
    color: #fff;
    z-index: 10000;
  }
  position: relative;
  flex: 1;
  overflow-y: auto;
  box-sizing: border-box;
  padding-top: 80px;
  padding-bottom: 60px;
  /*滚动条样式*/
  &::-webkit-scrollbar {
    width: 6px;
  }
  &::-webkit-scrollbar-thumb {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 20px;
    background-color: #c1c1c1;
  }
  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
    border-radius: 0;
    background-color: #ebebeb;
  }

  .lookHistory {
    background: #f3f3f3;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    padding: 10px 0;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--history-text-color);
    top: 50px;
    background: #f8f8f8;
    z-index: 99;
    &:hover {
      text-decoration: underline;
    }

    span {
      cursor: pointer;
      padding: 10px 20px;
    }
  }

  .lookHistoryLoad {
    background: transparent;
    font-size: 16px;
    color: #787878;
    &:hover {
      text-decoration: none;
    }

    i {
      margin: 10px 0;
    }
  }
  .messages-layout {
    padding: 0 15px 0px 15px;
  }
}

.no-more {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 10px 0;
  font-size: 12px;
  color: #b4b4b4;
}

.day-first-time {
  color: #b4b4b4;
  margin: 20px 0;
  line-height: 20px;
  font-size: 13px;
  text-align: center;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;

  span {
    display: block;
    margin: 0 15px;
  }
}

.mobile {
  .penetrate {
    overflow: hidden;
  }
  .nopenetrate {
    overflow: auto;
  }
  .cool-lightbox {
    padding: 0;
    position: fixed;
    width: 100%;
    height: 100%;
    z-index: 99999;
    zoom: 1;
  }
  .cool-lightbox__inner {
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    padding: 0 !important;
    box-sizing: border-box;
    .cool-lightbox__wrapper {
      height: 120%;
    }
  }
}
.moreMsg {
  position: fixed;
  bottom: 60px;
  right: 0;
  cursor: pointer;

  span {
    display: inline-block;
    width: fit-content;
    min-width: 95px;
    line-height: 33px;
    background-color: var(--header-bg);
    opacity: 0.7;
    border-radius: 50px 0 0 50px;
    text-align: left;
    font-size: 13px;
    color: #ffffff;
    padding-right: 10px;

    i {
      margin-left: 12px;
    }
  }
}
.tip {
  width: 100%;
  font-size: 12px;
  margin-bottom: 10px;
  padding-top: 55px;
  .left_border {
    width: 35%;
    height: 0px;
    border-top: 1px solid #ccc;
    float: left;
    position: relative;
    top: 5px;
  }
  .content {
    width: 30%;
    float: left;
    text-align: center;
    color: #b4b4b4;
  }
  .right_border {
    float: left;
    width: 35%;
    position: relative;
    top: 5px;
    height: 0px;
    border-top: 1px solid #ccc;
  }
  .clear {
    clear: both;
  }
  #notice {
    padding: 5px;
    margin: 10px auto 5px;
    width: 80%;
    word-break: break-all;
    line-height: 20px;
    border: 1px solid #ccc;
    text-align: left;
    background: #ffffb9;
    border-radius: 5px;
  }
}
</style>
